export default __webpack_public_path__ + "static/media/DSC00372.2a325933.JPG";